{
    "ShowMore": "Mostra di più",
    "ShowLess": "Mostra meno",
    "NAME": "LanguageSnackbar"
}